import React, { VoidFunctionComponent } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { prepareProps } from 'record-it-components/utils/propUtils';
import { ForgotPasswordForm } from 'record-it-components/form/ForgotPasswordForm/ForgotPasswordForm';
import { useEventCallback } from 'record-it-components/hooks/useEventCallback';
import { PropsWithoutChildren } from 'record-it-components/utils/utilityTypes';
import { ApiAdapter } from '../../../classes/ApiAdapter/ApiAdapter';
import { RoutePaths } from '../../../classes/RoutePaths/RoutePaths';

export type ForgotPasswordPageProps = PropsWithoutChildren<
  Record<never, never>
>;

export const ForgotPasswordPage: VoidFunctionComponent<ForgotPasswordPageProps> =
  React.memo((props) => {
    prepareProps({ props, ignoreChildren: true });

    const [params] = useSearchParams();
    const emailParam = params.get('email') ?? '';

    const navigate = useNavigate();

    const sendPasswordResetEmail = useEventCallback(async (email: string) => {
      const response = await ApiAdapter.sendPasswordResetEmail({ email });
      if (response.success === false) {
        throw new Error(response.message);
      }
    });

    const handleCancel = useEventCallback(() => {
      navigate(RoutePaths.loginPage());
    });

    return (
      <ForgotPasswordForm
        sendPasswortResetMail={sendPasswordResetEmail}
        onCancel={handleCancel}
        key={emailParam}
        defaultEmail={emailParam}
        data-testid="ForgotPasswordPage.Form"
      ></ForgotPasswordForm>
    );
  });
